module.exports = __webpack_public_path__ + "static/media/ps.58d04301.png";